/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A bounded search for live events.
 * @export
 * @interface EventSearchRequest
 */
export interface EventSearchRequest {
    /**
     * Artist, team, show, or event name.
     * @type {string}
     * @memberof EventSearchRequest
     */
    keyword: string;
    /**
     * Optional provider attraction (performer) identifier. When set, results are pinned to that performer and keyword title matching is bypassed entirely.
     * @type {string}
     * @memberof EventSearchRequest
     */
    attractionId?: string;
    /**
     * Resolve keyword to a canonical performer before searching so namesake tribute and club nights do not outrank the artist's own dates. Disable for non-performer keywords such as a genre or venue name.
     * @type {boolean}
     * @memberof EventSearchRequest
     */
    matchArtist?: boolean;
    /**
     * Include cancelled and postponed events, which are excluded by default. Off-sale events are always returned: they are real dates that are sold out or not yet on sale, and duplicate resale listings are collapsed by deduplication instead.
     * @type {boolean}
     * @memberof EventSearchRequest
     */
    includeUnavailable?: boolean;
    /**
     * Optional city, region, postal code, or natural-language location filter.
     * @type {string}
     * @memberof EventSearchRequest
     */
    location?: string;
    /**
     * Earliest event local calendar date, inclusive.
     * @type {Date}
     * @memberof EventSearchRequest
     */
    startDate?: Date;
    /**
     * Latest event local calendar date, inclusive.
     * @type {Date}
     * @memberof EventSearchRequest
     */
    endDate?: Date;
    /**
     * Optional event segment, genre, or subgenre name.
     * @type {string}
     * @memberof EventSearchRequest
     */
    classification?: string;
    /**
     * Search radius around the resolved location.
     * @type {number}
     * @memberof EventSearchRequest
     */
    radius?: number;
    /**
     * 
     * @type {string}
     * @memberof EventSearchRequest
     */
    radiusUnit?: EventSearchRequestRadiusUnitEnum;
    /**
     * Zero-based result page.
     * @type {number}
     * @memberof EventSearchRequest
     */
    page?: number;
    /**
     * Maximum events returned per page.
     * @type {number}
     * @memberof EventSearchRequest
     */
    limit?: number;
    /**
     * Only return events whose cheapest listing is at or below this amount. Requires sort=price, since only the price-ordering provider can filter on price; any other sort is rejected rather than silently returning unfiltered results. There is deliberately no matching minimum: the provider's lower-bound filter does not behave as a price floor, so a band cannot be expressed and must not be simulated.
     * @type {number}
     * @memberof EventSearchRequest
     */
    maxPrice?: number;
    /**
     * Result ordering. "price" ranks by each event's cheapest listing and is served by a single provider, because providers that cannot order by price would make a merged list unordered while still looking ranked.
     * @type {string}
     * @memberof EventSearchRequest
     */
    sort?: EventSearchRequestSortEnum;
}


/**
 * @export
 */
export const EventSearchRequestRadiusUnitEnum = {
    Miles: 'miles',
    Km: 'km'
} as const;
export type EventSearchRequestRadiusUnitEnum = typeof EventSearchRequestRadiusUnitEnum[keyof typeof EventSearchRequestRadiusUnitEnum];

/**
 * @export
 */
export const EventSearchRequestSortEnum = {
    Relevance: 'relevance',
    Date: 'date',
    Distance: 'distance',
    Price: 'price'
} as const;
export type EventSearchRequestSortEnum = typeof EventSearchRequestSortEnum[keyof typeof EventSearchRequestSortEnum];


/**
 * Check if a given object implements the EventSearchRequest interface.
 */
export function instanceOfEventSearchRequest(value: object): value is EventSearchRequest {
    if (!('keyword' in value) || value['keyword'] === undefined) return false;
    return true;
}

export function EventSearchRequestFromJSON(json: any): EventSearchRequest {
    return EventSearchRequestFromJSONTyped(json, false);
}

export function EventSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'keyword': json['keyword'],
        'attractionId': json['attraction_id'] == null ? undefined : json['attraction_id'],
        'matchArtist': json['match_artist'] == null ? undefined : json['match_artist'],
        'includeUnavailable': json['include_unavailable'] == null ? undefined : json['include_unavailable'],
        'location': json['location'] == null ? undefined : json['location'],
        'startDate': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'endDate': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
        'classification': json['classification'] == null ? undefined : json['classification'],
        'radius': json['radius'] == null ? undefined : json['radius'],
        'radiusUnit': json['radius_unit'] == null ? undefined : json['radius_unit'],
        'page': json['page'] == null ? undefined : json['page'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'maxPrice': json['max_price'] == null ? undefined : json['max_price'],
        'sort': json['sort'] == null ? undefined : json['sort'],
    };
}

export function EventSearchRequestToJSON(json: any): EventSearchRequest {
    return EventSearchRequestToJSONTyped(json, false);
}

export function EventSearchRequestToJSONTyped(value?: EventSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'keyword': value['keyword'],
        'attraction_id': value['attractionId'],
        'match_artist': value['matchArtist'],
        'include_unavailable': value['includeUnavailable'],
        'location': value['location'],
        'start_date': value['startDate'] == null ? value['startDate'] : value['startDate'].toISOString().substring(0,10),
        'end_date': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString().substring(0,10),
        'classification': value['classification'],
        'radius': value['radius'],
        'radius_unit': value['radiusUnit'],
        'page': value['page'],
        'limit': value['limit'],
        'max_price': value['maxPrice'],
        'sort': value['sort'],
    };
}

